import { render, staticRenderFns } from "./DuplicatesModal.vue?vue&type=template&id=e2701808"
import script from "./DuplicatesModal.vue?vue&type=script&lang=js"
export * from "./DuplicatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports